import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getCurrentShift = async () => {
  const { data } = await SigliveServiceV1({
    method: 'GET',
    url: `/monitoring-operator/shift/current`,
  });

  return data?.data;
};

export default getCurrentShift;
